<template>
    <div v-if="token_toggle_list && token_toggle_list.length > 1">
        <v-select
            v-model="signed_in_as"
            :items="token_toggle_list"
            :label="$t('common.signed_in_as')"
            :menu-props="{
                contentClass: 'custom-menu-content'
            }"
            @update:model-value="select_token($event)"
            density="compact"
            item-color="neutral"
            item-title="title"
            item-value="token_index"
            min-width="300"
            variant="outlined"
            autofocus
            hide-details
        >
            <template
                v-if="token_toggle_list.length"
                #selection
            >
                {{ token_toggle_list[signed_in_as].title }}
            </template>
        </v-select>
    </div>

</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { parse_token } from '@old/utils/helpers/token_helper.js'
import { user_mixin } from '@old/mixins/user_mixin/index.js'

export default {
    name: 'Token',
    props: {},
    mixins: [user_mixin],
    components: {},
    data() {
        return {
            menu: false,
            signed_in_as: 0,
        }
    },
    computed: {
        token_toggle_list() {
            if (this.user_tokens === null) {
                return []
            }
            const token_toggle_list = []

            for (const token_index in this.user_tokens.token_list) {
                const token_json = parse_token(this.user_tokens.token_list[token_index].token)

                const selected = String(token_index) === String(this.user_tokens.selected_token)

                token_toggle_list.push({
                    title: this.title(token_json),
                    selected: selected,
                    token_index: token_index,
                })
            }
            return token_toggle_list
        },
        ...mapGetters(['token_json']),
    },
    watch: {
        'user_tokens.selected_token': {
            handler(val) {
                if (val !== null) {
                    this.signed_in_as = val
                    this.$emit('close')
                }
            },
            immediate: true,
        },
    },
    methods: {
        title(token_json) {
            const { u_name, d_name, proxy } = token_json

            if (proxy) {
                const proxy_name = d_name.join(', ')

                return this.$t('common.proxy_for_x', { x: proxy_name })
            }

            return u_name
        },
        subtitle(token_json) {
            const { d_name, proxy } = token_json

            if (proxy) {
                const proxy_name = d_name.join(', ')
                return this.$t('common.proxy_for_x', { x: proxy_name })
            }

            return null
        },
        ...mapActions([]),
    },
    beforeCreate() {
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
    },
    beforeUpdate() {
    },
    updated() {
    },
}
</script>
<style scoped>


</style>
